import React from 'react';
import { getEcCom } from '../../util/convert';

export default class Encrypt extends React.Component{
    constructor(){
        super();
    }
    render(){
        const { WeaInputEncrypt } = getEcCom();
        const { value,fieldAttr,fieldObj } = this.props;
        const type = fieldAttr.htmltype === 2 ? 'TEXTAREA' : '';
        const decryptValue = fieldObj && fieldObj.decryptValue;
        const hideEye = fieldAttr.encryptFlag === 3;

        return (
            <WeaInputEncrypt 
                value={value} 
                decryptValue={decryptValue}
                onClick={this.onClick}
                type={type} 
                noDesensitization={hideEye}  
            />
        )
    }
    onClick = (v) =>{
        const { fieldObj } = this.props;
        fieldObj && fieldObj.changeDecryptValue(v);
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/public/wf-encrypt/index.js